module.exports = __webpack_public_path__ + "img/not-authorized.ad9e52c2.svg";